import {useBAData} from "../../context"

const Player = ({player}) =>{
    return (
        <tr>
            <td>{player.ranking}</td>
            <td>{player.tier}</td>  
            {/* <td>{player.playerId}</td> */}
            <td>{player.player}</td> 
            <td>{player.position}</td> 
            <td>{player.team}</td> 
            <td>{player.age}</td> 
            <td>{player.previous}</td> 
            <td>{player.movement}</td>                  
        </tr>
    )
}
    
    

export const DisplayTable = () => {
    const {activeBADataSet} = useBAData()
    return (<div>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Ranking</th>
                            <th>Tier</th>
                            {/* <th>Player ID</th> */}
                            <th>Player</th>
                            <th>Position</th>
                            <th>Team</th>
                            <th>Age</th>
                            <th>Previous</th>
                            <th>Movement</th>
                        </tr>
                    </thead>
                    <tbody>
                        {activeBADataSet && activeBADataSet.length > 0 && activeBADataSet.map((player,i) => <Player key={`BAPlayer ${player}${i}`} player={player} />)} 
                    </tbody>
                </table>
    </div>)
}